import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateCounterpartyBankResponse from "./customerRefundCandidateCounterpartyBankResponse";
import RefundPaymentType from "./refundPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CustomerRefundCandidateRefundPaymentResponse {
  @observable
  paymentType!: RefundPaymentType;

  @observable
  @Type(() => CustomerRefundCandidateCounterpartyBankResponse)
  counterpartyBank?: CustomerRefundCandidateCounterpartyBankResponse;

  @observable
  counterpartyName?: string;

  @observable
  counterpartyStreetAddress?: string;

  @observable
  counterpartyCityAddress?: string;

  @observable
  counterpartyCountryId?: string;

  @observable
  additionalAvMessage?: string;
}

export default class CustomerRefundCandidateRefundPayment extends CustomerRefundCandidateRefundPaymentResponse {
  @observable
  @Type(() => CustomerRefundCandidateCounterpartyBankResponse)
  counterpartyBank: CustomerRefundCandidateCounterpartyBankResponse = new CustomerRefundCandidateCounterpartyBankResponse();
}
